export const beforeSubmitPracticeTest = [
  {
    description: 'submit nhưng vẫn còn thời gian',
    conditions: [
      {
        description: 'submit nhưng vẫn còn thời gian',
        remainQuestion: {
          equal: 0,
        },
      },
    ],
    action: {
      showPopUp: {
        icon: 'info',
        title: 'Xem kỹ lại đáp án',
        message: 'Bạn vẫn còn thời gian làm bài, xem kỹ lại đáp án để câu hỏi cao hơn nha.',
        placeholder: ['remainTimeInMinutes'],
        confirm: {
          label: 'Nộp luôn',
          action: {
            setValue: {
              isSubmitAfterWarning: true,
              isAnswersAllQuestions: true,
              isChangedAfterDoubleCheck: {
                type: 'compare',
                fields: ['userAnswers', 'lastUserAnswers'],
                operation: 'notEqual',
              },
            },
            submitTest: {},
            routeTo: {},
          },
        },
        cancel: {
          label: 'Xem lại',
          action: {
            setValue: {
              isSubmitAfterWarning: false,
              isAnswersAllQuestions: true,
              isDoubleCheck: true,
              lastUserAnswers: {
                type: 'assign',
                from: 'userAnswers',
              },
            },
          },
        },
      },
    },
  },
  // {
  //   description: 'Submit trong thoi gian lam bai va lam xong tat ca cac cau hoi',
  //   conditions: [
  //     {
  //       description: 'Submit trong thoi gian lam bai va lam xong tat ca cau hoi',
  //       remainTimeInSecond: {
  //         greaterThan: 0,
  //       },
  //       remainQuestion: {
  //         equal: 0,
  //       },
  //     },
  //   ],
  //   action: {
  //     submitTest: {},
  //     showPopUp: {
  //       type: 'success',
  //       icon: 'success',
  //       message:
  //         'Chúc mừng bạn đã hoàn thành xong bài đúng hạn. Cùng nhau xem kết quả và đáp án nhé.',
  //       confirm: {
  //         label: 'Xem đáp án',
  //         action: {
  //           routeTo: {},
  //         },
  //       },
  //     },
  //   },
  // },
  {
    description: 'Submit khi chưa xong hết tất cả các câu hỏi',
    conditions: [
      {
        description: 'Submit khi chưa xong hết tất cả các câu hỏi',
        remainQuestion: {
          greaterThan: 0,
        },
      },
    ],
    action: {
      showPopUp: {
        icon: 'warning',
        title: 'Thiếu câu',
        // TODO support regex to get variable name
        message: 'Bạn còn thiếu {{remainQuestion}} câu chưa trả lời',
        placeholder: ['remainQuestion'],
        confirm: {
          label: 'Nộp luôn',
          action: {
            submitTest: {},
            routeTo: {},
          },
        },
        cancel: {
          label: 'Xem lại',
          action: {},
        },
      },
    },
  },
  {
    description: 'Time up and answer all questions',
    conditions: [
      {
        description: 'Time up and answer all questions',
        remainTimeInSecond: {
          lessThanEqual: 0,
        },
        remainQuestion: {
          equal: 0,
        },
      },
    ],
    action: {
      submitTest: {},
      showPopUp: {
        type: 'success',
        icon: 'success',
        message:
          'Chúc mừng bạn đã hoàn thành bài trong {{completeTimeInMinutes}} phút. Cùng nhau xem kết quả và đáp án nhé.',
        placeholder: ['completeTimeInMinutes'],
        confirm: {
          label: 'Xem đáp án',
          action: {
            routeTo: {},
          },
        },
      },
    },
  },
];
